import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

const wrap: CSSObject = {
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  background: color.white,
  borderRadius: radius.xl,
  marginBottom: '16px',
  minWidth: 0,
  [mobile]: {
    padding: '20px 16px',
    borderRadius: radius.lg,
    marginBottom: '12px',
  },
};

const row: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  padding: '12px 0',
  [mobile]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8,
  },
};

const rows: CSSObject = {
  ...row,
  alignItems: 'center',
  gap: '8px',
  [mobile]: {
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: 8,
    '> p:first-of-type': {
      flexBasis: '100%',
      minWidth: 0,
    },
    'input:not([type=checkbox]):not([type=radio]), select': {
      flex: '1 1 auto',
      width: 'auto !important',
      minWidth: 0,
    },
  },
};

const startRows: CSSObject = {
  ...row,
  alignItems: 'flex-start',
};

const col: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px 0',
};

const btns = (): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px 0 30px 0',
  gap: '0 8px',
  '> button': {
    width: '160px',
    height: '52px',
    borderRadius: radius.md,
    fontSize: 16,
    fontWeight: 600,
  },
  'button:nth-of-type(1)': {
    color: color.grey700,
    background: color.grey75,
  },
  'button:nth-of-type(2)': {
    color: color.white,
    background: color.primary,
  },
  [mobile]: {
    padding: '24px 0 8px',
    '> button': {
      flex: 1,
      width: 'auto',
    },
  },
});

const inputStyle: CSSObject = {
  width: '450px',
  maxWidth: '100%',
  height: '40px',
  fontSize: '14px',
  marginLeft: '5px',
};

export { wrap, rows, startRows, col, btns, inputStyle, row };
